import React from 'react';
import { useTheme } from '@material-ui/styles';

const ContactSupport = () => {
  const theme = useTheme();

  const fill = theme.palette.type === 'light' ? 'black' : 'white';

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C6.48578 2 2 6.48578 2 12C2 17.5142 6.48578 22 12 22C17.5142 22 22 17.5142 22 12C22 6.48578 17.5142 2 12 2ZM12 17.8333C11.5399 17.8333 11.1667 17.4601 11.1667 17C11.1667 16.5399 11.5399 16.1667 12 16.1667C12.4601 16.1667 12.8333 16.5399 12.8333 17C12.8333 17.4601 12.4601 17.8333 12 17.8333ZM13.3191 12.535C13.0242 12.6708 12.8333 12.9683 12.8333 13.2926V13.6667C12.8333 14.1266 12.4608 14.5 12 14.5C11.5392 14.5 11.1667 14.1266 11.1667 13.6667V13.2926C11.1667 12.32 11.7383 11.4284 12.6209 11.0208C13.47 10.6301 14.0833 9.59247 14.0833 9.08328C14.0833 7.93506 13.1491 7 12 7C10.8509 7 9.91672 7.93506 9.91672 9.08328C9.91672 9.54333 9.5441 9.91672 9.08328 9.91672C8.62247 9.91672 8.25 9.54333 8.25 9.08328C8.25 7.01587 9.93243 5.33328 12 5.33328C14.0676 5.33328 15.75 7.01587 15.75 9.08328C15.75 10.2092 14.7733 11.8642 13.3191 12.535Z"
        fill={fill}
      />
    </svg>
  );
};

export default ContactSupport;
